import {
  ADD_USER_TRAINING_FAIL,
  ADD_USER_TRAINING_REQUEST,
  ADD_USER_TRAINING_SUCCESS,
} from "../../types/user/trainingTypes";

export const addUserTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_USER_TRAINING_REQUEST:
      return {
        ...state,
        addUserTrainingLoading: true,
      };
    case ADD_USER_TRAINING_SUCCESS:
      return {
        ...state,
        addUserTrainingLoading: false,
        addUserTrainingInfo: payload,
        addUserTrainingError: "",
      };
    case ADD_USER_TRAINING_FAIL:
      return {
        ...state,
        addUserTrainingLoading: false,
        addUserTrainingInfo: [],
        addUserTrainingError: payload,
      };
    default:
      return state;
  }
};
